export const USER_STATUSES = Object.freeze({
  Active: 1,
  NotActive: 2,
  DemandsActivation: 3,
  IsBlocked: 4
})
